import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./en/resource";
import translationAR from "./ar/resource";
import { DEFAULT_LANGUAGE } from "@/config/config";

const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lang") || DEFAULT_LANGUAGE, // Read once at startup
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
